"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TierPricing = void 0;
var _material = require("@mui/material");
var _consts = require("../../../consts");
var _react = _interopRequireDefault(require("react"));
var _types = require("../../../types");
var _utils = require("../../../utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var tierHeaderStyling = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _types.BoostTier.BASIC, "linear-gradient(90deg, #7249F5 0%, #B9F 100%)"), _types.BoostTier.PREMIUM, "linear-gradient(90deg, var(--purple-900, #4A1D96) 0%, #7249F5 82.21%)"), _types.BoostTier.VIP, "linear-gradient(180deg, rgba(187, 153, 255, 0.00) 0%, rgba(187, 153, 255, 0.50) 100%), #4A1D96"), _types.BoostTier.PLUS, "linear-gradient(90deg, #7249F5 0%, #B9F 100%)");
var TierPricing = exports.TierPricing = function TierPricing(props) {
  var _boostProductTierConf;
  var theme = props.theme,
    tier = props.tier,
    _props$term = props.term,
    term = _props$term === void 0 ? "yearly" : _props$term,
    isMobile = props.isMobile,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "default" : _props$variant,
    hidePricing = props.hidePricing,
    _props$promotionPerce = props.promotionPercentOff,
    promotionPercentOff = _props$promotionPerce === void 0 ? 0 : _props$promotionPerce,
    _props$promotionCredi = props.promotionCredit,
    promotionCredit = _props$promotionCredi === void 0 ? 0 : _props$promotionCredi,
    _props$isLanding = props.isLanding,
    isLanding = _props$isLanding === void 0 ? false : _props$isLanding;
  var tierConfig = _consts.boostProductTierConfig[term][tier];
  if (!tierConfig) {
    return null;
  }
  var _calculatePerMonthPri = (0, _utils.calculatePerMonthPrice)(term, tierConfig.price, tierConfig.originalPrice),
    perMonthPrice = _calculatePerMonthPri.perMonthPrice;
  var promoActive = !!promotionPercentOff || !!promotionCredit;
  var afterPromotionPrice = (0, _utils.calculatePriceAfterPromotion)(perMonthPrice, promotionPercentOff, promotionCredit);
  var monthlyConfig = (_boostProductTierConf = _consts.boostProductTierConfig[_types.BoostTerm.MONTHLY]) === null || _boostProductTierConf === void 0 ? void 0 : _boostProductTierConf[tier];
  var _ref = monthlyConfig || {},
    monthlyPrice = _ref.price;
  var isDarkBackground = theme === "dark";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center ".concat(isMobile ? "pb-4" : "pb-6", " ").concat(variant === "compact" ? "flex-row justify-between" : "flex-col"),
    style: {
      borderBottomWidth: 1,
      borderBottomColor: "#9CA3AF"
    }
  }, isLanding && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      display: "grid",
      width: "100%",
      paddingY: "1.125rem",
      background: tierHeaderStyling[tier],
      borderRadius: "20px 20px 0px 0px",
      placeItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold  ".concat(isDarkBackground ? "text-boost-primary-300" : "text-boost-primary-500", " ").concat(isLanding ? "text-white" : ""),
    style: {
      lineHeight: "120%"
    }
  }, "".concat((0, _utils.getBoostTierDisplayName)(tier)))), !isLanding && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl font-bold  ".concat(isDarkBackground ? "text-boost-primary-300" : "text-boost-primary-500"),
    style: {
      lineHeight: "120%"
    }
  }, "".concat((0, _utils.getBoostTierDisplayName)(tier))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(isLanding ? "mt-4" : "")
  }, (0, _utils.getBoostTierDisplayName)(tier) === 'VIP' && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      background: "#D9D9D9",
      borderRadius: "15px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    sx: {
      textAlign: "center",
      fontFamily: "Gilroy",
      fontWeight: 700,
      fontSize: "1.125rem",
      background: "linear-gradient(90deg, #6999FF 11.18%, #4F078F 98.8%)",
      WebkitBackgroundClip: 'text',
      color: 'transparent',
      marginX: "1rem"
    }
  }, "Most Valuable")), (0, _utils.getBoostTierDisplayName)(tier) === 'Premium' && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      background: "rgba(217, 217, 217, 0.20)",
      borderRadius: "15px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    sx: {
      textAlign: "center",
      fontFamily: "Gilroy",
      fontWeight: 700,
      fontSize: "1.125rem",
      background: "linear-gradient(90deg, rgba(189, 210, 255, 0.90) -5.88%, rgba(207, 183, 255, 0.90) 114.02%)",
      WebkitBackgroundClip: 'text',
      color: 'transparent',
      marginX: "1rem"
    }
  }, "Most Popular"))), !hidePricing && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(isMobile ? "mt-4" : "mt-6", " ").concat(variant === "compact" ? "text-end" : "")
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold ".concat(isDarkBackground ? "text-white" : "text-black", " ").concat(variant === "compact" ? "text-lg" : "text-3xl", "\n              ").concat(tier === _types.BoostTier.VIP ? "text-boost-primary-500" : "", "\n              "),
    style: {
      lineHeight: "120%"
    }
  }, "$", promoActive ? afterPromotionPrice.toFixed(2) : perMonthPrice.toFixed(2), "/mo"), promoActive && /*#__PURE__*/_react["default"].createElement("p", {
    className: "grid text-2xl ".concat(isDarkBackground ? "text-white" : "text-black", " text-center line-through items-end")
  }, "$", perMonthPrice.toFixed(2), "/mo"), term === _types.BoostTerm.YEARLY && !promoActive && /*#__PURE__*/_react["default"].createElement("p", {
    className: "grid text-2xl ".concat(isDarkBackground ? "text-white" : "text-black", " text-center line-through items-end")
  }, "$", monthlyPrice.toFixed(2), "/mo")), /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-semibold text-xs text-center ".concat(isDarkBackground ? "text-netural-400" : "text-neutral-600", " ").concat(variant === "compact" ? "" : "mt-2"),
    style: {
      lineHeight: "120%"
    }
  }, term === "yearly" ? "billed annually" : "billed monthly")));
};